import Pyramid from './Pyramid';

export default Pyramid;
